import {
    memo
} from "react";
import type {
    FlagIconOptions,
    FlagIcon
} from "./type";
import {
    getFlagIconSize,
    getFlagCode
} from "./stylesheet";
import type {
    LucideProps
} from "lucide-react-native";
import Flag from ".";

const FLAG_ICON_CACHE = new Map<string, FlagIcon>();

export const createFlagIcon = (code: string, {
    baseUrl
}: FlagIconOptions = {}): FlagIcon => {
    const currentCode = getFlagCode({
        code
    });

    const cacheKey = `${baseUrl ?? ""}|${currentCode}`;

    const cachedIcon = FLAG_ICON_CACHE.get(cacheKey);

    if(cachedIcon) {
        return cachedIcon;
    }

    const FlagIconComponent = memo(({
        style,
        size
    }: LucideProps) => <Flag
        size={getFlagIconSize({
            size
        })}
        isDecorative={true}
        code={currentCode}
        baseUrl={baseUrl}
        style={style}
    />);

    FlagIconComponent.displayName = `FlagIcon(${currentCode})`;

    FLAG_ICON_CACHE.set(cacheKey, FlagIconComponent);

    return FlagIconComponent;
};
